import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import cogoToast from 'cogo-toast-react-17-fix';
import Modal from '../../Utils/Modal';
import Loader from '../../components/Loader';
import CustomDropDown from '../../components/CustomDropDown';
import { Delay, EMAIL_CHECK } from '../../Utils/helper';
import { CONTACT_US, GET_SUBJECT } from '../../Utils/constant';
import API from '../../ApiConfig';
import style from './UserGuide.module.css';

const NeedHelp = () => {
  const [popup, setPopup] = useState(false);
  const [option, setOption] = useState({subject:"Select query type"});
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    comment: '',
  });
  const [errors, setErrors] = useState({});
  
  const User = useSelector(state => state.User);


  const handleNeedHelp = async (e) => {
    e.preventDefault();
    setLoading(true);
    cogoToast.info("Please Wait...");
    await Delay();
    try {
      const res = await API.post(GET_SUBJECT + User.user_type);
      setLoading(false);
      if (res.status === 200) {
        setList(res.data.data);
        setIsSubmit(false)
        setPopup(true);
      }
    } catch (err) {
      setLoading(false);
      cogoToast.error(err.response?.data?.message || "An error occurred.");
    }
  };


  const validate = () => {
    const { name, email, comment } = formData;
    const newErrors = {};
    let isValid = true;

    if (!name) {
      isValid = false;
      newErrors.name = "Enter name!!";
    }
    if (!email) {
      isValid = false;
      newErrors.email = "Enter email!!";
    } else if (!EMAIL_CHECK(email)) {
      isValid = false;
      newErrors.email = "Enter correct email!!";
    }
    if (!comment) {
      isValid = false;
      newErrors.comment = "Enter comment";
    }

    if (!option.subject || option.subject === "Select query type"){
      isValid=false;
      newErrors.option="Please Select Query"
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };


  const handleSelect = (item) => {
    setOption(item);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const formdata = {
        name:formData.name,
        email:formData.email,
        subject_id: option.subject_id,
        text: option.subject,
      };

      setLoading(true);
      await Delay();
      try {
        const res = await API.post(CONTACT_US, formdata);
        setLoading(false);
        if (res.status === 200) {
          setIsSubmit(true);
          setFormData('')
          setErrors({})
          setOption({subject:"Select query type"})
        }
      } catch (err) {
        setLoading(false);
        setIsSubmit(true);
        setFormData('')
        setErrors({})
        setOption({subject:"Select query type"})
        cogoToast.error(err.response?.data?.message || "An error occurred.");
      }
    }
  };

  const handleCancel=()=>{
      setFormData('')
      setErrors({})
      setOption({subject:"Select query type"})
      setPopup(false)
  }
  return (
    <div>
      <button className={style.bottomRight} onClick={handleNeedHelp}>
        <img src='/needhelp.svg' alt='needhelp' /> Need Help?
      </button>

      <Modal
        title="Need Assistance? We’re Here to Help"
        isOpen={popup}
        blockOutsideClick={true}
        children={
          !isSubmit ? (
            <form style={{ padding: "10px" }} onSubmit={handleSubmit}>
              <Loader isOpen={loading} />
              <div className={style.needHelpContainer}>
                <div className={style.heading}>
                  Please fill out the form below to raise your query. Our support team will review your request and get back to you shortly.
                </div>
                <div className={style.needHelpDetails}>
                  <div>
                    <input
                      type="text"
                      className={style.input}
                      name="name"
                      value={formData.name}
                      placeholder="Name"
                      onChange={handleChange}
                    />
                    {errors.name && <span style={{ color: "red", fontWeight: "500" }}>{errors.name}</span>}
                  </div>
                  <div>
                    <input
                      type="text"
                      className={style.input}
                      name="email"
                      value={formData.email}
                      placeholder="Email"
                      onChange={handleChange}
                    />
                    {errors.email && <span style={{ color: "red", fontWeight: "500" }}>{errors.email}</span>}
                  </div>
                  <div>
                    <CustomDropDown list={list} selectedOption={option.subject} onSelect={handleSelect} />
                    <div style={{margin:"7px 0px"}}>
                    {errors.option && <span style={{ color: "red", fontWeight: "500" }}>{errors.option}</span>}
                    </div>
                  </div>
                  <div>
                    <textarea
                      className={style.needHelpTextArea}
                      name="comment"
                      value={formData.comment}
                      placeholder="Enter Comment"
                      onChange={handleChange}
                    />
                    {errors.comment && <span style={{ color: "red", fontWeight: "500" }}>{errors.comment}</span>}
                  </div>
                </div>
              </div>
              <hr />
              <div style={{ display: "flex" }}>
                <button type="submit" className="btn btn-primary" style={{ width: "50%" }}>
                  Submit
                </button>
                <button className="btn btn-secondary" style={{ width: "50%", border: "1px solid lightgray" }} onClick={() => handleCancel()}>
                  Cancel
                </button>
              </div>
            </form>
          ) : (
            <div className={style.Submit}>
              <div className={style.VerifiedImg}>
                <img src="/checkcircle.svg" alt="checkcircle.svg" />
              </div>
              <div className={style.Text}>
                <div className={style.mainText}>Thank You for Reaching Out!</div>
                <div className={style.subText}>We’ve received your query and our support team is on it. Expect a response within 24 hours.</div>
              </div>
              <button className="btn btn-primary" style={{ width: "100%" }} onClick={() => setPopup(false)}>
                Close
              </button>
            </div>
          )
        }
        onClose={() => handleCancel()}
        isHelp
      />
    </div>
  );
};

export default NeedHelp;
